// Add your custom JS here.
(function($) {

  // navigation dropdown hover
  document.addEventListener("DOMContentLoaded", function(){
    if (window.innerWidth > 992) {
    
      document.querySelectorAll('#main-menu .nav-item').forEach(function(everyitem){
    
        everyitem.addEventListener('mouseover', function(e){
    
          let el_link = this.querySelector('a[data-bs-toggle]');
    
          if(el_link != null){
            let nextEl = el_link.nextElementSibling;
            el_link.classList.add('show');
            nextEl.classList.add('show');
          }
    
        });
        everyitem.addEventListener('mouseleave', function(e){
          let el_link = this.querySelector('a[data-bs-toggle]');
    
          if(el_link != null){
            let nextEl = el_link.nextElementSibling;
            el_link.classList.remove('show');
            nextEl.classList.remove('show');
          }
        })
      });
    
    }
  });


  // navbar
  $(function() {
    $(window).on('load scroll', function() {
      if ($(this).scrollTop() > 120) {
        $('#wrapper-navbar').addClass('scrolled');
      } else {
        $('#wrapper-navbar').removeClass('scrolled');
      }
    });
  });


  // footer-menu ドロップダウンを無効化
  $(function() {
    const footerDropdown = $('#footer-menu .dropdown');
    $(footerDropdown).each(function(){
      $(this).find('.dropdown-toggle').removeAttr('id data-toggle data-bs-toggle aria-haspopup aria-expanded').end()
      .find('.dropdown-menu').removeAttr('aria-labelledby');
    })
    $(footerDropdown).find('.dropdown-toggle').on('click', function(){
      return false;
    })
  })
  

  // to-top
  $(function() {
    let showFlag = false;
    const topBtn = $('.to-top');    
    topBtn.css('bottom', '-100px');
    $(window).on('scroll', function () {
        if ($(this).scrollTop() > 100) {
            if (showFlag == false) {
                showFlag = true;
                topBtn.stop().animate({'bottom' : '10px'}, 200); 
            }
        } else {
            if (showFlag) {
                showFlag = false;
                topBtn.stop().animate({'bottom' : '-100px'}, 200); 
            }
        }
    });
  });

  // page-link-scroll
  $(function() {
    let headerHeight = 0;
    headerHeight = $('#main-nav').outerHeight();
    const urlHash = location.hash;
    if(urlHash) {
      $('body,html').stop().scrollTop(0);
      setTimeout(function () {
        scrollToAnker(urlHash);
      }, 100);
    }
    $('a.link-scroll, a.nav-link').on('click', function(){
      const href= $(this).attr('href').replace(/.*#/, '');
      if(href.length > 0) {
        const hash = '#' + href;
        scrollToAnker(hash);
        return false;
      }
    });
    function scrollToAnker(hash) {
      const target = $(hash);
      const position = target.offset().top - headerHeight;
      $('body,html').stop().animate({scrollTop:position}, 500);
      return false;
    }
  });

  // MW WP Form
	// エラー位置にスクロール
	if ( $('.mw_wp_form .error')[0] ) {
		const errorEl = $('.mw_wp_form .error').eq(0);
		const position = errorEl.parent().offset().top - 150;
		$('body,html').delay(200).animate({scrollTop:position}, 600, 'swing');
	}

  // 確認画面でスクロール
  if ($('.mw_wp_form.mw_wp_form_confirm')[0]){
		const position = $('.mw_wp_form.mw_wp_form_confirm').eq(0).offset().top - 150;
		$('body,html').delay(200).animate({scrollTop:position}, 600, 'swing');
  }

    // 完了画面でスクロール
    if ($('.mw_wp_form.mw_wp_form_complete')[0]){
      const position = $('.mw_wp_form.mw_wp_form_complete').eq(0).offset().top - 150;
      $('body,html').delay(200).animate({scrollTop:position}, 600, 'swing');
    }

})(jQuery);